import { createFileRoute } from '@tanstack/react-router'
import { claimTypesEnum } from 'User/utils/claims'
import ActivityContainer from 'Work/containers/ActivityContainer'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/activities/$activityId')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <ActivityContainer />
        </Guard>
    ),
})
